/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type ListDatasetRowsPathParams = NonNullable<operations['listDatasetRows']['parameters']['path']>;

export type ListDatasetRowsQueryParams = NonNullable<operations['listDatasetRows']['parameters']['query']>;

export interface Input extends ListDatasetRowsPathParams {
  apiVersion?: string;
  query?: ListDatasetRowsQueryParams;
}

export async function listDatasetRows(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/projects/{projKey}/datasets/{datasetId}/rows', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
